import PropTypes from "prop-types";
import { Component } from "react";

export default class SentryBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    sentry: PropTypes.object.isRequired,
  };

  componentDidCatch(error, errorInfo) {
    const { sentry } = this.props;

    const scope = sentry.getCurrentScope();

    scope.setTag("react", "yes");
    scope.setTag("rendered", "no");

    Object.keys(errorInfo).forEach((key) => {
      scope.setExtra(key, errorInfo[key]);
    });

    sentry.captureException(error);
  }

  render() {
    return this.props.children;
  }
}
